import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import React from 'react'
import Todolist from './components/Todolist'
function App() {
  return (
    <React.Fragment>
      <Todolist />
    </React.Fragment>
  )
}

export default App
